export default [

     {
          path: '/deliverable-details/:id',
          name: 'DeliverableDetails',
          component: () => import("@/views/Page/StrategicPlan/Deliverable/DeliverableDetails.vue"),
           meta: {
               title: 'DeliverableDetails',
          },
     }
];